module.exports = "/images/checkbox-selected.svg?a14dfd1d796dc65ea61fea02004f2ef6";